(function () {
  function shuffleAllGrid(grid) {
    if (!grid || grid.dataset.nazvaFeaturedAllShuffled === 'true') return;

    const limit = Number(grid.dataset.productLimit || 0);
    const items = Array.from(grid.querySelectorAll('[data-nazva-featured-all-item]'));

    for (let index = items.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [items[index], items[randomIndex]] = [items[randomIndex], items[index]];
    }

    items.forEach((item, index) => {
      grid.appendChild(item);
      item.hidden = Boolean(limit && index >= limit);
      item.style.setProperty('--animation-order', String(index + 1));
    });

    grid.dataset.nazvaFeaturedAllShuffled = 'true';
  }

  function setActiveTab(root, activeButton) {
    const buttons = root.querySelectorAll('[data-nazva-featured-tab]');
    const panels = root.querySelectorAll('[data-nazva-featured-panel]');
    const activePanelId = activeButton.getAttribute('aria-controls');

    buttons.forEach((button) => {
      const isActive = button === activeButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      const isActive = panel.id === activePanelId;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });
  }

  function initFeaturedTabs(root) {
    if (!root || root.dataset.nazvaFeaturedTabsReady === 'true') return;

    root.querySelectorAll('[data-nazva-featured-all-grid]').forEach(shuffleAllGrid);

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-nazva-featured-tab]');
      if (!button || !root.contains(button)) return;

      setActiveTab(root, button);
    });

    root.dataset.nazvaFeaturedTabsReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-nazva-featured-tabs]').forEach(initFeaturedTabs);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (event) => {
    initFeaturedTabs(event.target.querySelector('[data-nazva-featured-tabs]'));
  });
})();
